import { NEW_CHANNELS_PAGE } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useNewChannelsPage() {
  return useIsFeatureEnabled(NEW_CHANNELS_PAGE);
}
